import Vue from "vue";
import App from "./App";
import Axios from "axios";
import VueRouter from "vue-router";
import BootstrapVue from "bootstrap-vue";
import { routes } from "./routes/index";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap/dist/css/bootstrap.css";
import "./assets/css/style.css";
import "./assets/css/default.css";
import VueCookies from "vue-cookies";
import money from 'v-money';
import VModal from 'vue-js-modal'

Vue.use(VModal, { componentName: "lefmodal" })
Vue.use(money);
Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(Axios);
Vue.use(VueCookies);

Vue.config.productionTip = false;

const router = new VueRouter({
  routes,
  mode: "history"
});

new Vue({
  el: "#app",
  router,
  render: h => h(App)
});
